import React, { useState } from 'react';
import 'twin.macro';
import { UserLocale } from 'types/user';
import { useFormState } from 'react-final-form';
import { RegistreAppelPDFSettings } from '../../Print/Registre/types';
import { buildRegistreAppelPDFParams } from 'containers/RegistreAppel/Preview/Registre/Sidebar/buildRegistreAppelPDFParams';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';

interface Props {
  schoolyearId: string;
  schoolId: string;
  from: Date;
  to: Date;
  lng: UserLocale;
  tz: string;
}

export function Body(props: Props) {
  const { schoolyearId, schoolId, from, to, lng, tz } = props;
  const { values } = useFormState<RegistreAppelPDFSettings>();

  const url = new URL(
    `/print/annee-scolaire/${schoolyearId}/ecole/${schoolId}/appels/registre`,
    window.location.origin,
  );
  url.search = buildRegistreAppelPDFParams({
    from,
    to,
    lng,
    tz,
    settings: values,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildRegistreAppelPDFParams({
      from,
      to,
      lng,
      tz,
      settings: values,
    }),
  });

  return (
    <IframePreviewPDF
      onePage
      landscape
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
    />
  );
}
